export enum lists {
   unchecked = 'unchecked',
   approved = 'approved',
   deleted = 'deleted'
}

export enum lang {
   pt = 'pt',
   en = 'en'
}